export enum AnalyticsEventType {
  REDIRECT = 'redirect',
}
